<style lang="scss" scoped>
.container-help {
  align-items: flex-start;
  background-color: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  padding: 15px;
  transition: all 0.3s ease;
  width: 340px;
}

.container-help span {
  color: grey;
  font-size: 16px;
  font-weight: bold;
}

.container-help textarea {
  width: 100%;
  margin-bottom: 10px;
}

.container-help input {
  margin-bottom: 5px;
  border: 1px solid #c7c7c7;
  padding: 5px;
  width: 100%;
}

.container-help p{
  text-align: center;
  margin-top: 20%;
  font-size: 0.9em;
}

.container-help__header {
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
}

.container-help__form {
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 100%;

  label {
    text-transform: unset;
  }

  .btn-primary {
    align-self: flex-end;
    padding-bottom: 0.2em;
    margin-top: 5px
  }
  .invalid{
    margin: 0px 0px 10px 40px;
    font-size: 0.7em;
  }
  .alert-captcha{
    padding: 5px;
  }
}

.container-help__success {
  margin: 2rem 0;

  p {
    box-sizing: border-box;
    margin: 0 0 0.5rem 0;
    padding: 0 2rem;
  }
}
</style>

<template>
  <form @submit.prevent="createpost()" class="container-help">
    <div class="container-help__header">
      <span>Entre em contato conosco</span>

      <a @click="close()" class="btn btn-clear float-right" aria-label="Close"></a>
    </div>

    <div v-if="success" class="container-help__form">
      <dr-field
        v-for="(field, name) in form"
        :validators.sync="$v.form[name]"
        :field.sync="field"
        :key="name"
      />

      <div class="alert-captcha">
        <dr-captcha
          ref="hel-recaptcha"
          @on-check="checkCaptcha"
        />
      </div>

      <dr-submit
        class="btn-sm btn-primary "
        :disabled="$v.$invalid || !isCaptchaVerified"
        text="Enviar mensagem"
        :sending="sending"
        :class="{ loading: isLoading }"
      />
    </div>

    <div v-else class="container-help__success">
      <p>Sua mensagem foi enviada com sucesso!</p>

      <p>Em breve um de nossos atendentes entrará em contato.</p>

      <p>Obrigado</p>
    </div>
  </form>
</template>
<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import { form, validations } from '@/data/formData/help.js'
import drCaptcha from '@/components/form/recaptcha'

export default {
  components: {
    drSubmit,
    drField,
    drCaptcha
  },
  data () {
    return {
      form,
      isLoading: false,
      sending: false,
      success: true,
      email: '',
      message: '',
      localActive: '',
      isCaptchaVerified: false
    }
  },
  validations: {
    form: validations
  },

  methods: {
    close () {
      this.$emit('closeHelp', false)
      if (!this.localActive) {
        this.form.email.value = null
        this.form.message.value = null
      }
    },

    checkCaptcha (value) {
      this.isCaptchaVerified = value
    },

    handleErrors (err) {
      if (err.status === 400 || err.code === 400) {
        this.fn_FLATTEN_OBJECT(err.errors.children).then(
          (res) => {
            this.sending = false
            this.fn_HIDE_PROGRESS()
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.form)
          }
        )
      } else {
        console.log(err)
        this.sending = false
        this.fn_HIDE_PROGRESS()
        this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
      }
    },

    createpost () {
      if (this.isCaptchaVerified) {
        this.isLoading = true
        this.$http.post(`/contact`, { contact: { email: this.form.email.value, message: this.form.message.value } })
          .then(
            (res) => {
              this.fn_HIDE_PROGRESS()
              this.form.email.value = null
              this.form.message.value = null
              this.success = false
              setTimeout(() => {
                this.success = true
                this.close()
              }, 9000)
              this.isLoading = false
            }
          )
          .catch((err) => {
            this.handleErrors(err)
            this.isLoading = false
          })
      }
    }
  }
}

</script>
